var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container container--login account-login" },
    [
      _c("h1", { staticClass: "heading heading--2 account-login__heading" }, [
        _vm._v("Log In")
      ]),
      _c("div", { staticClass: "login__main" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "small-12 medium-5 column" }, [
            _c("div", { staticClass: "login__column" }, [_vm._t("default")], 2)
          ]),
          _vm._m(0),
          _c(
            "div",
            { staticClass: "small-12 medium-5 column login__alt-container" },
            [
              _c("div", { staticClass: "login__column" }, [
                _c("p", { staticClass: "login__message" }, [
                  _vm._v(_vm._s(_vm.message))
                ]),
                _vm._m(1)
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "small-12 medium-2 column login__divider" },
      [_c("div", { staticClass: "login__divider__line" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login__button login__button--register" }, [
      _c("p", [_vm._v("Need an Account?")]),
      _c(
        "a",
        {
          staticClass: "button button--secondary",
          attrs: { href: "/account/register" }
        },
        [_vm._v("Sign Up")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }